var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useRef, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import i18n from '../../../i18n';
import { Section, Container, Flex, Text, Carousel, CarouselItem, Box, Button, IconButton } from '@homeexchange/design';
import { HomeCard } from './homecard';
import { toggleFavorite } from '../../../actions/homeFavorites';
import { trackButtonClick } from '../../../utils/utils-ts';
import styles from './recommendationsCarousel.module.scss';
import Utils from '../../../utils/utils';
export var RecommendationsCarousel = function (_a) {
    var _b;
    var recommendations = _a.recommendations, recommendationsTotal = _a.recommendationsTotal, user = _a.user, isLogged = _a.isLogged, recommendationsSeeMore = _a.recommendationsSeeMore;
    var carouselRef = useRef(null);
    var _c = useState({
        shouldDisplayNext: false,
        shouldDisplayPrev: false
    }), navigationState = _c[0], setNavigationState = _c[1];
    var initialHomeFavorites = useSelector(function (state) { return state.homeFavorites || []; });
    var _d = useState(initialHomeFavorites), homeFavorites = _d[0], setHomeFavorites = _d[1];
    var dispatch = useDispatch();
    var handleToggleFavorite = useCallback(function (homeId) {
        dispatch(toggleFavorite(homeId, homeFavorites));
        if (homeFavorites.includes(homeId)) {
            var updatedFavorites = homeFavorites.filter(function (id) { return id !== homeId; });
            setHomeFavorites(updatedFavorites);
            dispatch({
                type: 'REMOVE_HOME_FAVORITE',
                homeFavorites: homeId
            });
        }
        else {
            var updatedFavorites = __spreadArray(__spreadArray([], homeFavorites, true), [homeId], false);
            setHomeFavorites(updatedFavorites);
            dispatch({
                type: 'ADD_HOME_FAVORITE',
                homeFavorites: homeId
            });
        }
    }, [dispatch, homeFavorites]);
    var handleNextClick = function () {
        if (carouselRef.current) {
            carouselRef.current.scrollNext();
        }
    };
    var handlePrevClick = function () {
        if (carouselRef.current) {
            carouselRef.current.scrollPrev();
        }
    };
    var locale = i18n.language;
    var isUserCollection = (_b = user === null || user === void 0 ? void 0 : user.isCollection) === null || _b === void 0 ? void 0 : _b.call(user);
    var handleCTAClick = function () {
        var _a;
        trackButtonClick('recommendation_carousel', 'click_recommendation_carrousel_cta', (_a = user === null || user === void 0 ? void 0 : user.isCollection) === null || _a === void 0 ? void 0 : _a.call(user));
    };
    var addSearchTypeToUrl = function (url) {
        if (!url)
            return url;
        var urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.set('search_type', 'recommendation');
        return urlObj.pathname + urlObj.search;
    };
    if (!recommendations || recommendations.length < 8) {
        return null;
    }
    return (React.createElement("div", { "data-theme": "regular", className: styles['carousel-container'] },
        React.createElement(Section, { isTopBottomPadding: true, color: "tertiary" },
            React.createElement(Container, { isFluid: true },
                React.createElement(Flex, { gap: "8" },
                    React.createElement(Flex, { gap: "4", alignItems: "center", justifyContent: "center", flexWrap: "nowrap" },
                        React.createElement("img", { src: "".concat(Utils.getCloudfrontDomain(), "/images/website/migration/search/calendar.svg"), alt: "Recommendations Carousel" }),
                        React.createElement(Flex, { gap: "0", direction: "column" },
                            React.createElement(Text, { isBold: true, size: "lg" }, i18n.t('search:page.search.closeDates.carrousel.section.title')),
                            React.createElement(Text, null, i18n.t('search:page.search.closeDates.carrousel.section.subheader')))),
                    React.createElement(Flex, { direction: "row", gap: "1", justifyContent: "space-between", alignItems: "center", isFullWidth: true },
                        React.createElement(Flex, { direction: "column", gap: "1" },
                            React.createElement(Text, { isBold: true, size: "lg" }, i18n.t('search:page.search.closeDates.carrousel.title', {
                                nb: recommendationsTotal
                            })),
                            React.createElement(Text, null, i18n.t('search:page.search.closeDates.carrousel.subheader'))),
                        React.createElement(Flex, { direction: "row", gap: "4", hideOnMobile: true },
                            React.createElement(IconButton, { icon: "arrow-thin", size: "medium", "aria-label": "Previous", onClick: handlePrevClick, disabled: !navigationState.shouldDisplayPrev }),
                            React.createElement(IconButton, { icon: "arrow-thin-right", size: "medium", "aria-label": "Next", onClick: handleNextClick, disabled: !navigationState.shouldDisplayNext }))),
                    React.createElement(Carousel, { ref: carouselRef, onNavigationStateChange: setNavigationState, paddingElementWrapper: true, itemsPerBreakpoint: {
                            xs: { items: 1, peek: 15 },
                            sm: { items: 1, peek: 15 },
                            md: { items: 2, peek: 60 },
                            lg: { items: 3, peek: 50 },
                            xl: { items: 3, peek: 50 }
                        } },
                        recommendations.map(function (home, index) { return (React.createElement(CarouselItem, { key: index },
                            React.createElement(HomeCard, { result: home, locale: locale, isLogged: isLogged, isUserCollection: isUserCollection, homeFavorites: homeFavorites, handleToggleFavorite: handleToggleFavorite, format: "list", hideFixedDates: false, user: user, trackingEvent: 'click_recommendation_carrousel', origin: 'suggestion_carousel' }))); }),
                        React.createElement(CarouselItem, null,
                            React.createElement(Flex, { alignItems: "center", justifyContent: "center", isFullHeight: true },
                                React.createElement(Box, { isFullHeight: true, color: "tertiary", className: styles['carousel-item'] },
                                    React.createElement(Flex, { alignItems: "center", justifyContent: "center", direction: "column", isFullHeight: true },
                                        React.createElement(Text, { center: true }, i18n.t('search:page.search.closeDates.carrousel.lastResult')),
                                        React.createElement(Button, { color: "tertiary", href: addSearchTypeToUrl(recommendationsSeeMore), onClick: handleCTAClick }, i18n.t('search:page.search.closeDates.carrousel.cta'))))))),
                    React.createElement(Button, { color: "tertiary", href: addSearchTypeToUrl(recommendationsSeeMore), onClick: handleCTAClick }, i18n.t('search:page.search.closeDates.carrousel.cta')))))));
};
